import { render } from "./Payslip.vue?vue&type=template&id=5fe440de&scoped=true"
import script from "./Payslip.vue?vue&type=script&lang=js"
export * from "./Payslip.vue?vue&type=script&lang=js"

import "./Payslip.vue?vue&type=style&index=0&id=5fe440de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe440de"]])

export default __exports__